import { z } from "zod";

// ─── Collection Operator view schemas (feature 012) ───────────────────────────
// These types describe the read-only debt-collection view exposed to the
// collection_operator role.  Financial amounts are deliberately excluded.

export const CollectionActionTypeSchema = z.enum([
  "pre_due_reminder",
  "overdue_reminder",
  "formal_demand",
]);
export type CollectionActionType = z.infer<typeof CollectionActionTypeSchema>;

export const CollectionEmailStatusSchema = z.enum([
  "draft",
  "queued",
  "sending",
  "sent",
  "failed",
  "skipped",
]);
export type CollectionEmailStatus = z.infer<typeof CollectionEmailStatusSchema>;

/** A single row in the collection operator view.
 *  Contains only non-financial, status-level information about each action. */
export const CollectionActionItemSchema = z.object({
  id: z.string().uuid(),
  client_name: z.string(),
  action_date: z.string().date(),
  action_type: CollectionActionTypeSchema,
  max_days_overdue: z.number().int().min(0),
  /** Number of invoices covered by this action — NOT the invoice UUIDs or amounts. */
  invoice_count: z.number().int().min(0),
  email_to: z.string(),
  email_recipients: z.array(z.string()),
  email_subject: z.string().nullable(),
  has_snapshot: z.boolean(),
  error_message: z.string().nullable(),
  resend_message_id: z.string().nullable(),
  email_status: CollectionEmailStatusSchema,
  sent_at: z.string().datetime({ offset: true }),
});
export type CollectionActionItem = z.infer<typeof CollectionActionItemSchema>;

export const CollectionActionDetailSchema = CollectionActionItemSchema.extend({
  email_body: z.string().nullable(),
  email_html: z.string().nullable(),
  email_snapshot_html: z.string().nullable(),
});
export type CollectionActionDetail = z.infer<typeof CollectionActionDetailSchema>;

export const CollectionActionListResponseSchema = z.object({
  items: z.array(CollectionActionItemSchema),
  total: z.number().int().min(0),
});
export type CollectionActionListResponse = z.infer<typeof CollectionActionListResponseSchema>;

export const CollectionActionDetailResponseSchema = z.object({
  item: CollectionActionDetailSchema,
});
export type CollectionActionDetailResponse = z.infer<typeof CollectionActionDetailResponseSchema>;
